import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Text, Button } from '@rsos/components/capstone/base';
import { PENDING, ACCEPTED } from '../Common/utils';
import { PendingRequestsBadge } from './InboundAlerts.styles';
import InboundAlertsTable from './InboundAlertsTable';
import ViewRequestsModal from './ViewRequestsModal/ViewRequestsModal';

const InboundAlerts = () => {
  const [isViewRequestsModalOpened, setIsViewRequestsModalOpened] =
    useState(false);

  const linksFrom = useSelector(
    state => state.alertsRouting.agencyLinks.linksFrom,
  );
  const pendingRequests = linksFrom.filter(l => l.status === PENDING);

  const handleCloseModal = () => {
    setIsViewRequestsModalOpened(false);
  };
  const handleViewRequestsModal = () => {
    setIsViewRequestsModalOpened(true);
  };

  return (
    <>
      <Box horizontal justify="space-between" mb={10}>
        <Box>
          <Text size="normal" fontWeight="bold" color="primaryText">
            Shared Inbound Alerts
          </Text>
          <Box mt="4px">
            <Text size="small" color="secondaryText">
              Allow other agencies to share their alerts with you. Below is the
              list of agencies that are sharing their alerts with your agency.
            </Text>
          </Box>
        </Box>
        <Button btnType="tertiary" onClick={handleViewRequestsModal}>
          <Box color="secondaryText">View requests</Box>
          {pendingRequests.length > 0 && (
            <PendingRequestsBadge>
              {pendingRequests.length}
            </PendingRequestsBadge>
          )}
        </Button>
      </Box>
      <InboundAlertsTable
        linksFrom={linksFrom.filter(l => l.status === ACCEPTED)}
      />
      <ViewRequestsModal
        isOpened={isViewRequestsModalOpened}
        onClose={handleCloseModal}
        requests={pendingRequests}
      />
    </>
  );
};

export default InboundAlerts;
